import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { api, errMsg } from "../lib/api";

const FIELDS = [
  ["points", "Punti", "0.5", 1000],
  ["bonuses", "Bonus", "1", 50],
  ["exact", "Esatti", "1", 50],
];

export const AdjustmentDialog = ({ tid, row, onClose, onSaved, client = api }) => {
  const [v, setV] = useState({ points: 0, bonuses: 0, exact: 0 });
  useEffect(() => {
    if (row) setV({ points: row.adjustment || 0, bonuses: row.adjust_bonuses || 0, exact: row.adjust_exact || 0 });
  }, [row]);

  const save = async (e) => {
    e.preventDefault();
    try {
      await client.put(`/tournaments/${tid}/adjustments/${row.user_id}`, {
        points: Number(v.points), bonuses: Math.trunc(Number(v.bonuses)), exact: Math.trunc(Number(v.exact)),
      });
      toast.success("Rettifica salvata");
      onSaved?.();
      onClose();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  return (
    <Dialog open={!!row} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#121824] border-[#26334D] max-w-sm" data-testid="adjustment-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-black uppercase">Rettifica</DialogTitle>
          <DialogDescription>Aggiungi (+) o togli (−) a {row?.name}. Bonus ed esatti cambiano solo il conteggio, i punti si rettificano a parte.</DialogDescription>
        </DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <div className="grid grid-cols-3 gap-3">
            {FIELDS.map(([k, label, step, max]) => (
              <label key={k} className="space-y-1">
                <span className="block text-center font-mono text-[10px] uppercase tracking-widest text-slate-400">{label}</span>
                <Input type="number" step={step} min={-max} max={max} required value={v[k]} onChange={(e) => setV({ ...v, [k]: e.target.value })} data-testid={`adjustment-${k}-input`}
                  className="h-12 text-center font-display text-xl bg-[#0A0D14] border-[#26334D]" />
              </label>
            ))}
          </div>
          <Button type="submit" data-testid="adjustment-save-button" className="w-full h-11 rounded-full bg-amber-500 hover:bg-amber-400 text-[#0A0D14] font-bold">Salva</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
